import _ from 'lodash';

class ListController {
  constructor(ModelFactory, $stateParams, Resource, $scope) {
    "ngInject";
    let vm = this;
    vm.name = '';
    vm.viewType = "grid"; //grid | list
    vm.model = {};
    vm.modelEnum = "";
    vm.items = [];
    vm.dots = 200;
    init();

    function init() {
      vm.model = ModelFactory.getByEnum($stateParams.modelEnum);
      vm.modelEnum = $stateParams.modelEnum;

      Resource.getList(vm.model.name).then(res => {
        console.log("Resource:", res.data);
        vm.items = _.filter(res.data, vm.model.name + '.active');
      })

      $scope.$watch('vm.viewType', (newValue) => {
        console.log("View type cambiato:", newValue);
        if (newValue == 'list') {
          vm.dots = 500;
        }
        else {
          vm.dots = 200;
        }
      })
    };

  }
}

export default ListController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/list/list.controller.js